// Basic
import PropTypes from 'prop-types';
// Components
import Select from '@/common-utils/components/ui/select';
// Common
import getTranslatedText from '@/common-utils/functions/getTranslatedText';
// Lang
import { nsSimCard } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.actionSelected
 * @param root0.setActionSelected
 * @returns {JSX} SelectSimSelectionMode
 */
function SelectSimSelectionMode({ actionSelected, setActionSelected }) {

    const SIM_CARD_ACTIONS_LIST = [
        {
            name: getTranslatedText('select_options.sim.select', nsSimCard),
            value: 'select'
        },
        {
            name: getTranslatedText('select_options.sim.input', nsSimCard),
            value: 'input'
        }
    ];

    return (
        <Select
            options={SIM_CARD_ACTIONS_LIST}
            value={actionSelected}
            onChange={(value) => setActionSelected(value)}
        />
    );
}

SelectSimSelectionMode.propTypes = {
    actionSelected: PropTypes.string.isRequired,
    setActionSelected: PropTypes.func.isRequired
};

export default SelectSimSelectionMode;